import { theme } from 'aimo-ui';
import {
  Card,
  CompanyBenefit,
  Maybe,
  PaymentType,
} from 'types/generatedSchemaTypes.ts';

export type SessionWithPayment = {
  paymentType?: Maybe<PaymentType>;
  corporateAccountUid?: Maybe<string>;
  cardId?: Maybe<string>;
};

export const getPaymentMethodUsedInSession = (
  session: SessionWithPayment,
  paymentCards: Maybe<Card>[] | undefined | null,
  companyBenefits: Maybe<CompanyBenefit>[] | undefined | null
) => {
  const paymentType = session?.paymentType;
  const corporateAccountUid = session?.corporateAccountUid;
  const cardId = session?.cardId;

  const companyBenefit = companyBenefits?.find(
    (benefit) => benefit?.benefitTargetUid === corporateAccountUid
  );

  const card = paymentCards?.find((card) => card?.cardId === cardId);

  switch (paymentType) {
    case 'CORPORATE_ACCOUNT':
      return {
        paymentMethodType: 'CORPORATE_ACCOUNT',
        paymentMethodInfo: companyBenefit?.name,
      };
    case 'CREDIT_CARD': {
      return {
        paymentMethodType: 'CREDIT_CARD',
        cardType: card?.type,
        paymentMethodInfo: card?.lastNums,
        // Wallet funding of the card (APPLE_PAY/GOOGLE_PAY) so consumers can
        // show the wallet brand mark instead of the scheme logo.
        walletPaymentMethod: card?.paymentMethod,
      };
    }
    case 'SWISH':
    case 'SWISH_NETS': {
      return {
        paymentMethodType: 'SWISH',
        paymentMethodInfo: 'Swish',
      };
    }
    case 'MOBILEPAY': {
      return {
        paymentMethodType: 'MOBILEPAY',
        paymentMethodInfo: 'MobilePay',
      };
    }
    default:
      return {
        paymentMethodType: undefined,
        paymentMethodInfo: undefined,
      };
  }
};

// Minimum height of the white sub-sheet to make first item visible while it is collapsed.
export const mobileSubSheetMinHeight = theme.normalising.heightPixel(210);
